<div
  #popupContentRef
  role="tooltip"
  class="med-popup__tooltip"
  (clickOutside)="medPopup.clickOutside$.next($event)"
  [style.max-width]="medPopup.maxWidth"
>
  <ng-template medHost></ng-template>
</div>
